/* global App */
const Backbone = require('backbone')
const { info } = require('util/logger')

module.exports = Backbone.Router.extend({

    routings: [],
    viewsMap: [],

    empty () {},

    createView (key, View, args) {
        info(`[LocalRouter] Navigated to ${key}`)

        if (!View) {
            info('[LocalRouter] Rendering null view. Key ${key}')
            return
        }

        // Existing view
        if (App.Views && App.Views.includes(View)) {
            return
        }

        App.Views.push(View)
        const view = new View(args)
        view.render()
    },

    reloadPage () {
        window.location.reload();
    },

    generateRoutes () {
        this.routings.forEach((routing) => {
            routing.path = new RegExp('(?:^|index.php\/)' + routing.path.source);
            this.route(routing.path, routing.key, (...args) => {
                routing.view().then((loadedView) => {
                    this.createView(routing.key, loadedView.default, args)
                })
            })
        })
    },
})
